'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { CartCurrencyMismatchBox } from '@feat/feat-cart/currency';
import { useState } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import { useAppExperienceAvailableDates } from '../_hooks/use-app-experience-available-dates';
import { FilterType } from '../_lib/experience-booking-utils';
import { AppDateModal } from './app-date-modal';
import { useExperienceFilterContext } from './app-experience-filter-provider';
import { AppExperienceOffersContainer } from './app-experience-offers-container';
import { AppExperienceOffersFilter } from './app-experience-offers-filter';
import { AppPersonModal } from './app-person-modal';
import { AppVariantModal } from './app-variant-modal';
export function AppExperienceOffers() {
  const $ = _c(32);
  const {
    ref,
    isScrollTop
  } = useIsScrollTop();
  const {
    experience,
    filter
  } = useExperienceFilterContext();
  const {
    availableDates
  } = useAppExperienceAvailableDates(experience.publicId, filter.selectedVariant, filter.selectedOptions);
  const [activeModal, setActiveModal] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setActiveModal(null);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const closeModal = t0;
  let t1;
  if ($[1] !== isScrollTop) {
    t1 = isConfirmed => {
      if (isConfirmed && !isScrollTop) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
      setActiveModal(null);
    };
    $[1] = isScrollTop;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const closeDateModal = t1;
  let t2;
  if ($[3] !== ref) {
    t2 = <span className="absolute -top-(--full-header-height) left-0" ref={ref} />;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = !isScrollTop;
  let t4;
  if ($[5] !== t3) {
    t4 = cx("fluid-container sticky top-[calc(var(--full-header-height)-var(--title-height-mobile))] z-10 bg-white pb-4 sm:static sm:col-span-5 sm:row-start-2 sm:px-0", {
      "border-primary/15 border-b sm:border-b-0": t3
    });
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="space-y-4 sm:sticky sm:top-(--full-header-height) sm:space-y-6 sm:pt-10"><h1 className="mt-8 h-(--title-height-mobile) overflow-hidden whitespace-nowrap font-heading1 sm:h-auto sm:whitespace-normal">Termin wählen</h1><AppExperienceOffersFilter onSelect={setActiveModal} /></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <div className={t4}>{t5}</div>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== experience.currency) {
    t7 = <CartCurrencyMismatchBox className="mb-4 sm:mb-6" productType="experience" productCurrency={experience.currency} />;
    $[10] = experience.currency;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <AppExperienceOffersContainer />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7) {
    t9 = <div className="fluid-container sm:col-span-7 sm:col-start-6 sm:row-start-2 sm:px-0 sm:pt-10">{t7}{t8}</div>;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t9) {
    t10 = <div className="sm:fluid-grid sm:fluid-container [--title-height-mobile:30px]">{t6}{t9}</div>;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = activeModal === FilterType.person;
  let t12;
  if ($[18] !== t11) {
    t12 = <AppPersonModal isOpen={t11} onClose={closeModal} onSubmit={closeModal} />;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = activeModal === FilterType.date;
  let t14;
  if ($[20] !== availableDates || $[21] !== closeDateModal || $[22] !== t13) {
    t14 = <AppDateModal isOpen={t13} onClose={closeDateModal} availableDates={availableDates} />;
    $[20] = availableDates;
    $[21] = closeDateModal;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  const t15 = activeModal === FilterType.variant;
  let t16;
  if ($[24] !== t15) {
    t16 = <AppVariantModal isOpen={t15} onClose={closeModal} />;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t10 || $[27] !== t12 || $[28] !== t14 || $[29] !== t16 || $[30] !== t2) {
    t17 = <>{t2}{t10}{t12}{t14}{t16}</>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t14;
    $[29] = t16;
    $[30] = t2;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
}
function useIsScrollTop() {
  const $ = _c(4);
  const [isScrollTop, setIsScrollTop] = useState(true);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      rootMargin: "105px",
      onChange: isIntersecting => setIsScrollTop(isIntersecting)
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    ref
  } = useIntersectionObserver(t0);
  let t1;
  if ($[1] !== isScrollTop || $[2] !== ref) {
    t1 = {
      ref,
      isScrollTop
    };
    $[1] = isScrollTop;
    $[2] = ref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}